import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "com.snap.camerakit.v3.features";
export interface RemoteApiInfo {
    apiSpecIds: string[];
}
function createBaseRemoteApiInfo(): RemoteApiInfo {
    return { apiSpecIds: [] };
}
export const RemoteApiInfo: MessageFns<RemoteApiInfo> = {
    encode(message: RemoteApiInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
        for (const v of message.apiSpecIds) {
            writer.uint32(10).string(v!);
        }
        return writer;
    },
    decode(input: BinaryReader | Uint8Array, length?: number): RemoteApiInfo {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRemoteApiInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.apiSpecIds.push(reader.string());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    create<I extends Exact<DeepPartial<RemoteApiInfo>, I>>(base?: I): RemoteApiInfo {
        return RemoteApiInfo.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<RemoteApiInfo>, I>>(object: I): RemoteApiInfo {
        const message = createBaseRemoteApiInfo();
        message.apiSpecIds = object.apiSpecIds?.map((e) => e) || [];
        return message;
    },
};
type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;
export type DeepPartial<T> = T extends Builtin ? T : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>> : T extends {
    $case: string;
} ? {
    [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]>;
} & {
    $case: T["$case"];
} : T extends {} ? {
    [K in keyof T]?: DeepPartial<T[K]>;
} : Partial<T>;
type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P : P & {
    [K in keyof P]: Exact<P[K], I[K]>;
} & {
    [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
};
export interface MessageFns<T> {
    encode(message: T, writer?: BinaryWriter): BinaryWriter;
    decode(input: BinaryReader | Uint8Array, length?: number): T;
    create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
    fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
